import GeneralAccount from '@/presentation/components/icons/general-account';
import Styles from '../../my-portfolio-brokerage-styles.scss';
import React from 'react';
const PortfolioCardSmall = ({ style, onClick, title, text, amount, link }) => {
    return (React.createElement("div", { className: style },
        React.createElement("div", { className: Styles.left },
            React.createElement(GeneralAccount, null),
            React.createElement("div", { className: Styles.infoContainer },
                React.createElement("div", { className: Styles.title }, title),
                React.createElement("div", { className: Styles.text }, text),
                React.createElement("div", { className: Styles.amount }, amount))),
        onClick && (React.createElement("div", { className: Styles.right, onClick: onClick }, "View"))));
};
export default PortfolioCardSmall;
